import { readonly, ref } from 'vue'
import { isPreviewHost } from '@/services/api.service'

// Dayforce tenants that see the SWP AI agent: any namespace under a regional
// demo prefix (nademo07, nademocsd14, apjdemo12) or a QA prefix (qaextazr1_,
// azqa874_).
const AI_ENABLED_NAMESPACE = /^(nademo|apjdemo|emeademo|ptdemo|predemo|qaextazr1_|azqa874_)/i

/**
 * Whether the AI agent is visible for this host and Dayforce namespace.
 * Local development and PR preview hosts always see it, for building and QA.
 * @param {object} root0 Visibility inputs.
 * @param {string} root0.hostname Page hostname.
 * @param {?string} [root0.namespace] Dayforce namespace from the user's token, empty when not embedded.
 * @returns {boolean} whether the AI agent is visible
 */
export const isAiEnabledFor = ({ hostname, namespace }) =>
  hostname === 'localhost' || isPreviewHost(hostname) || AI_ENABLED_NAMESPACE.test(namespace ?? '')

const aiEnabled = ref(isAiEnabledFor({ hostname: window.location?.hostname ?? '' }))

/**
 * Records the signed-in user's Dayforce namespace (empty when not embedded).
 * @param {?string} namespace Dayforce namespace.
 * @returns {void}
 */
export const setAiNamespace = (namespace) => {
  aiEnabled.value = isAiEnabledFor({ hostname: window.location?.hostname ?? '', namespace })
}

/**
 * Feature flag for the SWP AI agent: the chat, skill matching, agent logos,
 * and the AI skills heatmap.
 * @returns {Readonly<import('vue').Ref<boolean>>} whether the AI agent is visible
 */
export const useAiEnabled = () => readonly(aiEnabled)
